import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { formatCOP } from '../../../utils/currencyFormat';

interface RevenueChartProps {
    data?: { name: string; value: number }[];
}

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8'];

export default function RevenueChart({ data = [] }: RevenueChartProps) {
    // Si no hay datos, mostrar algo por defecto o vacío
    const hasData = data.length > 0;

    return (
        <div className="bg-white rounded-2xl p-6 border border-slate-200">
             <div className="flex items-center justify-between mb-6">
                <div>
                    <h2 className="text-lg font-bold text-slate-800">Ingresos por Método</h2>
                    <p className="text-sm text-slate-500 mt-1">Distribución de pagos hoy</p>
                </div>
            </div>
            
            <div className="h-64">
                {hasData ? (
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={data}
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={80}
                                fill="#8884d8"
                                paddingAngle={5}
                                dataKey="value"
                            >
                                {data.map((_, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip 
                                formatter={(value: number) => [formatCOP(value), 'Total']}
                                contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
                            />
                            <Legend verticalAlign="bottom" height={36}/>
                        </PieChart>
                    </ResponsiveContainer>
                ) : (
                    <div className="h-full flex flex-col items-center justify-center text-slate-400">
                        <i className="ri-pie-chart-2-line text-4xl mb-2"></i>
                        <p>No hay datos de ingresos hoy</p>
                    </div>
                )}
            </div>
        </div>
    );
}
